import ReactTooltip from "react-tooltip";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

type StatusCardProps = {
  status: string;
};

type InfoProps = {
  hiddenMobile?: boolean;
  isFixedWidth?: boolean;
};

type ShowTourProps = {
  showTour: boolean;
};

export const ContainerWrap = styled.div`
  position: relative;
`;

export const ContentCard = styled.div<ShowTourProps>`
  align-self: start;
  grid-area: bills;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  background-color: #fff;
  border-radius: 8px;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

type StatusWrapperProps = {
  hasIcon?: boolean;
};

export const StatusWrapper = styled.span<StatusWrapperProps>`
  ${({ hasIcon }) =>
    hasIcon &&
    css`
      display: flex;
      align-items: center;
      & img {
        width: 24px;
        height: 24px;
        margin-left: 8px;
      }
    `}
`;

export const HeaderCard = styled.div`
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 25px;

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

export const BillCompensationWrapper = styled.div`
  margin-top: 8px;
  width: 100%;
`;

export const TitleCard = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 16px;
  line-height: 1;
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  padding: 10px 0;
  margin: 0 25px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);

  & svg {
    color: ${({ theme }) => theme.colors.blue};
  }

  @media (max-width: 768px) {
    margin: 0 10px;
  }
`;

export const MonthYear = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 4px;
  background-color: #efefef;
  position: relative;

  & span:first-of-type {
    color: ${({ theme }) => theme.colors.blue};
    font-family: "Mangueira bold";
    font-size: 16px;
    line-height: 1;
    margin-bottom: 5px;
    text-transform: capitalize;
  }

  & span:last-of-type {
    font-size: 14px;
    line-height: 1;
  }

  @media (max-width: 768px) {
    padding: 10px;

    & span:first-of-type {
      font-size: 14px;
    }

    & span:last-of-type {
      font-size: 12px;
    }
  }
`;

export const Info = styled.div<InfoProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  ${({ isFixedWidth }) =>
    isFixedWidth &&
    css`
      width: 85px;
    `}

  & span:first-of-type {
    color: ${({ theme }) => theme.colors.blue};
    font-family: "Mangueira bold";
    font-size: 12px;
  }

  & span:last-of-type {
    font-size: 16px;
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    & span:first-of-type {
      font-size: 10px;
    }

    & span:last-of-type {
      font-size: 14px;
    }

    ${({ hiddenMobile }) =>
      hiddenMobile &&
      css`
        display: none;
      `}
  }
`;

export const StatusCard = styled.div<StatusCardProps>`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 5px;

  background-color: ${({ status, theme }) => {
    switch (status) {
      case "VENCIDO":
        return theme.colors.red;
      case "PAGO":
        return theme.colors.lightGreen;
      case "A_VENCER":
        return theme.colors.darkYellow;
      default:
        return "#000";
    }
  }};

  @media (max-width: 768px) {
    width: 5px;
    height: 5px;
  }
`;

export const NotBills = styled.span`
  margin: 0 25px 10px;
`;

export const StatusContent = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  justify-content: end;
  padding: 25px 10px;
`;

export const Button = styled(Link)`
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }

  & svg {
    margin-left: 5px;
    font-size: 16px;
  }
`;

export const ContentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 8px;

  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.colors.blue};
  }

  @media (max-width: 768px) {
    gap: 5px;
  }
`;

export const TooltipAiOutlineInfoCircle = styled(ReactTooltip)`
  padding: 21px 28px !important;
  opacity: 1 !important;
  max-width: 450px;
  width: 100%;

  & span {
    font-size: 14px;
    font-family: "Mangueira Bold";
    line-height: 22px;
  }

  & p {
    margin: 0;
    font-size: 14px;
    line-height: 22px;
  }

  @media (max-width: 768px) {
    padding: 10px 14px !important;
    max-width: 200px;
  }
`;
